import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	PassIdOption,
	ProductMillSetup,
	StandOption,
} from "../models/ProductMillSetup";

export const getProductMillSetup = async (
	productSizeId: number,
): Promise<ProductMillSetup[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProductSizeId", value: productSizeId },
		{ name: "ActiveOnly", value: false },
	];

	const resp = await apiService.callV2(
		"[MILL].[GetProductMillSetup]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as ProductMillSetup[];
	}
	throw new Error(resp.message || "Error fetching product mill setup");
};

export const upsertProductMillSetup = async (
	setup: ProductMillSetup,
): Promise<ProductMillSetup> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: setup.Id },
		{ name: "ProductSizeId", value: setup.ProductSizeId },
		{ name: "StandId", value: setup.StandId },
		{ name: "PassId", value: setup.PassId },
		{ name: "BarSize", value: setup.BarSize },
		{ name: "Comments", value: setup.Comments },
		{ name: "PassDepth", value: setup.PassDepth },
		{ name: "PassWidth", value: setup.PassWidth },
		{ name: "RollPart", value: setup.RollPart },
		{ name: "RolledAl", value: setup.RolledAl },
		{ name: "Active", value: setup.Active },
		{ name: "AlternativePassIds", value: setup.AlternativePassIds ?? "" },
	];

	const resp = await apiService.callV2(
		"[MILL].[UpsertProductMillSetup]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as ProductMillSetup;
	}
	throw new Error(resp.message || "Error saving product mill setup");
};

export const removeProductMillSetup = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2(
		"[MILL].[RemoveProductMillSetup]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting product mill setup");
	}
};

export const getActiveStands = async (): Promise<StandOption[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "StandType", value: "COMMON" },
		{ name: "OnlyActives", value: true },
	];

	const resp = await apiService.callV2("[MILL].[GetStands]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as StandOption[];
	}
	throw new Error(resp.message || "Error fetching stands");
};

export const getActivePassIds = async (): Promise<PassIdOption[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: true }];

	const resp = await apiService.callV2("[MILL].[GetPassIds]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as PassIdOption[];
	}
	throw new Error(resp.message || "Error fetching pass IDs");
};
